export default __webpack_public_path__ + "static/media/wallet-outline.e6b8b469.svg";